<template>
  <div class="mx-auto max-w-608 min-h-160 px-16 md:px-0 py-56 w-full">
    <h1 class="text-h1 text-center">You're one step closer to finding care</h1>
    <div class="flex justify-center mt-48">
      <div class="bg-grey-background-contrast box-shadow-md px-10 py-16 w-[200px] -mr-82 -rotate-6 self-start rounded-2xl">
        <div class="flex gap-8">
          <img src="@/images/avatars/alexis_t.png" alt="Alexis T" class="w-76 h-76 rounded-full" />
          <div>
            <p class="text-h4 whitespace-nowrap">Alexis T.</p>
            <star-rating :average="4" :count="22" :star-size="13" class="pt-4 pb-4" />
            <first-aid-badge :width="28" :height="28" />
          </div>
        </div>
        <icon-list :items="firstSitterItems" :iconSize="16" class="mt-8" textClasses="text-xs text-grey-body" />
      </div>
      <div class="bg-grey-background-contrast box-shadow-md px-10 py-16 w-[200px] rotate-6 self-end mt-44 rounded-2xl">
        <div class="flex gap-8">
          <img src="@/images/avatars/jordan_l.png" alt="Jordan L" class="w-76 h-76 rounded-full" />
          <div>
            <p class="text-h4 whitespace-nowrap">Jordan L.</p>
            <star-rating :average="5" :count="14" :star-size="13" class="pt-4 pb-4" />
            <div class="flex">
              <enhanced-background-check-badge :width="28" :height="28" />
              <motor-vehicle-record-badge :width="28" :height="28" />
            </div>
          </div>
        </div>
        <icon-list :items="secondSitterItems" :iconSize="16" class="mt-8" textClasses="text-xs text-grey-body" />
      </div>
    </div>
    <p class="text-lead text-center mt-48">Finding sitters that <span class="text-primary">fit</span> your needs</p>
    <loading-spinner class="w-24 h-24 mx-auto mt-24" />
  </div>
</template>

<script lang="ts">
import { Component } from 'vue';
import StarRating from '@/components/star_rating/StarRating.vue';
import IconList from '@/components/icon_list/IconList.vue';
import FirstAidBadge from '@/graphics/badges/FirstAidBadge.vue';
import EnhancedBackgroundCheckBadge from '@/graphics/badges/EnhancedBackgroundCheckBadge.vue';
import MotorVehicleRecordBadge from '@/graphics/badges/MotorVehicleRecordBadge.vue';
import HeartOutlineIcon from '@/graphics/icons/HeartOutlineIcon.vue';
import PlaceOutlineIcon from '@/graphics/icons/PlaceOutlineIcon.vue';
import LoadingSpinner from '@/icons/LoadingSpinner.vue';

export default {
  name: 'FilteredSearchLoading',
  components: {
    StarRating,
    IconList,
    FirstAidBadge,
    EnhancedBackgroundCheckBadge,
    MotorVehicleRecordBadge,
    LoadingSpinner,
  },
  props: {
    searchResultsLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minimumLoadingTimeElapsed: false,
    };
  },
  computed: {
    loadingComplete(): boolean {
      return this.minimumLoadingTimeElapsed && this.searchResultsLoaded;
    },
    firstSitterItems(): { icon: Component; text: string }[] {
      return [
        { icon: HeartOutlineIcon, text: '4 years experience' },
        { icon: PlaceOutlineIcon, text: '3 miles' },
      ];
    },
    secondSitterItems(): { icon: Component; text: string }[] {
      return [
        { icon: HeartOutlineIcon, text: '10 years experience' },
        { icon: PlaceOutlineIcon, text: '1 mile' },
      ];
    },
  },
  watch: {
    loadingComplete(isComplete: boolean) {
      if (isComplete) {
        this.$emit('loadingComplete');
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.minimumLoadingTimeElapsed = true;
    }, 3000);
  },
};
</script>
